import { render, staticRenderFns } from "./CompositionComplete.vue?vue&type=template&id=515339d2&"
import script from "./CompositionComplete.vue?vue&type=script&lang=js&"
export * from "./CompositionComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports